// store/versionStore.js
import { defineStore } from 'pinia'
// 1. 匯入 Vuex store
import store from '@/store/index.js'

export const useVersionStore = defineStore('versionStore', {
  state: () => ({
    isLoaded: false,
  }),
  actions: {
    async checkServerVersion() {
      // 若已載入過就直接 return
      if (this.isLoaded) return
      const localCartVersion = localStorage.getItem('cartVersion') ? localStorage.getItem('cartVersion') : null //購物車清單
      const localSettionsVersion = localStorage.getItem('settingsVersion') ? localStorage.getItem('settingsVersion') : null  //設置清單
      const localPostersVersion = localStorage.getItem('postersVersion') ? localStorage.getItem('postersVersion') : null //海報清單
      try {
        const res = await fetch('/api/load/versions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            cartVersion: localCartVersion,
            settionsVersion: localSettionsVersion,
            localPostersVersion : localPostersVersion,
          })
        })
        const json = await res.json()
        if (json.success) {
          if (json.isClearCart == true) {
            store.dispatch('clearAllCart')
            localStorage.setItem('cartVersion', json.cartVersion)
          }
          if (json.Settings != null) {
            const settingsObj = {};
            json.Settings.forEach(item => {
              settingsObj[item.s_key] = item.s_value;
            });
            localStorage.setItem('settings', JSON.stringify(settingsObj));
            localStorage.setItem('settingsVersion', json.settingsVersion)
          }
          if (json.PosterTitles != null) {
            localStorage.setItem('posterTitles', JSON.stringify(json.PosterTitles))
          }
          localStorage.setItem('postersVersion', json.postersVersion)
          this.isLoaded = true
        } else {
          console.warn('取得版本資料失敗', json.message)
        }
      } catch (err) {
        console.error('fetch error:', err)
      }
    },
    async getSettings() {
      const storedStr = localStorage.getItem('settings')
      if (storedStr) {
        const settingsObj = JSON.parse(storedStr)
        return settingsObj;
      }
    },
    async getPosterTitles() {
      const storedStr = localStorage.getItem('posterTitles')
      if (storedStr) {
        return JSON.parse(storedStr)
      }
    },
  },
})
